import { render } from "./MainPartners.vue?vue&type=template&id=5b9480c1&scoped=true"
import script from "./MainPartners.vue?vue&type=script&lang=js"
export * from "./MainPartners.vue?vue&type=script&lang=js"

import "./MainPartners.vue?vue&type=style&index=0&id=5b9480c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9480c1"]])

export default __exports__